import { AxiosResponse } from 'axios';
import { axiosInventoryInstance } from '@/config/apiConfig';
import { API_URL_CONFIG } from '@/config/urlConfig/apiUrlConfig';
import { CATEGORY_NAME, CATEGORY_TYPE } from '@/constant/product/product.const';
import { IFetchProduct, IProduct } from './product.type';

export const fetchProduct = ({
  operatorId,
  page,
  limit,
  order,
  orderBy,
  startDate,
  endDate,
  inactive,
  includeInactive,
  productCode,
  sourceProductId,
  name,
  barcode,
}: IFetchProduct): Promise<AxiosResponse<IProduct[], any>> => {
  return axiosInventoryInstance({
    url: API_URL_CONFIG.PRODUCT.GET_PRODUCT,
    params: {
      operatorId,
      page,
      limit,
      order,
      includeInactive,
      orderBy: orderBy === CATEGORY_TYPE ? CATEGORY_NAME : orderBy,
      ...(startDate ? { startDate } : {}),
      ...(endDate ? { endDate } : {}),
      ...(inactive ? { inactive } : {}),
      ...(productCode ? { productCode } : {}),
      ...(name ? { name } : {}),
      ...(sourceProductId ? { sourceProductId } : {}),
      ...(barcode ? { barcode } : {}),
    },
  });
};
